import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {UserStore} from 'src/app/modules/authentication/state/user.store';
import {API_PATH, RouterLinks} from '../../constants';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../../questions/question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionPasserService} from '../../services/question-passer-service';
import {DamageQuestionPasser} from '../../services/damage-question-passer';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../authentication/service/authentication.service';

declare const Dropzone: any;
declare const dropzonePreviewTemplate: any;
declare var $: any;

@Component({
    selector: 'app-damage-images-modal-alt',
    templateUrl: './damage-images-modal-alt.component.html',
    styleUrls: ['./damage-images-modal-alt.component.scss'],
    standalone: false
})
export class DamageImagesModalAltComponent implements OnInit, AfterViewInit {

  question: Question;
  subscription: Subscription;
  dropZone: any;
  acceptedFileTypes = 'image/*,video/mp4,video/x-m4v,video/*';
  questionResources: any[] = [];
  uniqueId = `uploader-alt-${newGuid()}`;
  uploadText = '';
  buttonDisabled = true;

  constructor(
    private userStore: UserStore,
    private globalQuestionService: GlobalQuestionService,
    private damageImagePasser: DamageQuestionPasser,
    private router: Router,
    private authService: AuthenticationService,
    private questionPasserService: QuestionPasserService
  ) {
    this.subscription = this.questionPasserService.updateComponent()
      .subscribe((question: Question) => {
        if (!question) {
          return;
        }
        this.authService.refreshToken()
          .subscribe(x => {
            this.userStore.update({
              access_token: x?.access_token,
              refresh_token: x?.refresh_token
            });
            this.setupDropZone();
            this.dropZone.removeAllFiles();
          });
        this.question = question;
        this.dropZone?.removeAllFiles();
        this.uploadText = '';
        this.buttonDisabled = true;
        if (this.question?.answer) {
          this.questionResources = [];
          const response = JSON.parse(this.question.answer);
          this.uploadText = response?.note;
          this.buttonDisabled = false;
          JSON.parse(response?.resources)?.forEach((res: any) => {
            const resource_id = res.resource_id;
            this.globalQuestionService.getUploadedFileDetails(resource_id)
              .subscribe((details: any) => {
                if (!details) {
                  return;
                }
                const mockFile = {
                  name: details[0].original_filename,
                  size: details[0].file_size
                };

                this.dropZone?.emit('addedfile', mockFile);
                this.dropZone?.emit('thumbnail', mockFile, `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`);
                this.dropZone?.emit('success', mockFile, resource_id);
                this.dropZone?.emit('complete', mockFile);
                this.dropZone.files.push(mockFile);
                this.buttonDisabled = false;
              });
          });
        }
      });
  }

  ngOnInit(): void {
    this.damageImagePasser.showDamageImageAltModalObservable
      .subscribe(x => {
        if (x) {
          this.showModal();
        } else {
          this.hideModal();
        }
      });
  }
  setupDropZone(): void {
    if (this.dropZone) {
      this.dropZone.destroy();
      this.dropZone = undefined;
    }
    this.dropZone = new Dropzone(`#uploader-alt-${this.uniqueId}`, {
      autoProcessQueue: true, // if false, call this.dropZone.processQueue()
      autoDiscover: false,
      acceptedFiles: this.acceptedFileTypes,
      previewTemplate: dropzonePreviewTemplate,
      thumbnailWidth: 204,
      thumbnailHeight: 204,
      url: API_PATH.UPLOAD_RESOURCE,
      headers: {
        Authorization: `Bearer ${this.userStore.getValue()?.access_token}`
      },
    }).on('thumbnail', (file: any) => {
      $(file.previewElement).addClass('has-thumbnail');
    }).on('success', (file: any, response: any) => {
      if (this.questionResources.length) {
        const questionResources = this.questionResources.find((qr: any) => qr.question_id === this.question.cent_aq_question_id);
        if (questionResources) {
          const resources = questionResources.resources;
          resources.push({ resource_id: response });
        } else {
          const resources: any[] = [];
          resources.push({ resource_id: response });
          this.questionResources.push({ question_id: this.question.cent_aq_question_id, resources });
        }
      } else {
        const resources: any[] = [];
        resources.push({ resource_id: response });
        this.questionResources.push({ question_id: this.question.cent_aq_question_id, resources });
      }
      if (this.questionResources?.length) {
        this.buttonDisabled = false;
      }
    }).on('error', (file: any, response: any) => {
      console.log(response)
      if (response?.indexOf('401') !== -1) {
        this.router.navigate([RouterLinks.Login], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
      }
    });
  }
  ngAfterViewInit(): void {

  }

  showModal(): void {
    $('#images-of-damage-modal-alt').modal('show');
  }

  hideModal(): void {
    (document.activeElement as HTMLElement)?.blur();
    $('#images-of-damage-modal-alt').modal('hide');
  }

  removeFile(resource_id: string): void {
    this.globalQuestionService.removeFile(resource_id);
  }

  cancelChanges(): void {
    this.dropZone?.removeAllFiles();
    this.uploadText = '';
    this.hideModal();
  }

  saveChanges(): void {
    const questionResources = this.questionResources.find((qr: any) => qr.question_id === this.question.cent_aq_question_id);
    const response = {resources: JSON.stringify(questionResources.resources), note: this.uploadText};
    this.dropZone?.removeAllFiles();
    this.uploadText = '';
    this.buttonDisabled = true;
    this.question.answer = JSON.stringify(response);
    this.questionPasserService.passQuestion(this.question);
    this.hideModal();
  }

}
